import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DisqusModule } from 'ngx-disqus';
import { WordPressModule } from 'ngx-wordpress';
import { CMS } from 'netlify-cms';
import * as browserd from '@angular/platform-browser-dynamic';
import { NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as nodemailer from 'nodemailer';

// firebase data
import { ReactiveFormsModule } from '@angular/forms';
import { AngularFireModule } from 'angularfire2';
import { environment } from '../environments/environment';
import { AngularFireDatabaseModule } from 'angularfire2/database';

// page loading
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressRouterModule } from '@ngx-progressbar/router';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { ProfileComponent } from './components/profile/profile.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { BlogComponent } from './components/blog/blog.component';
import { ContactComponent } from './components/contact/contact.component';
import { FooterComponent } from './components/footer/footer.component';
import { ResumeComponent } from './components/resume/resume.component';
import { OwlModule } from 'ngx-owl-carousel';
import { DisqusComponent } from './components/blog/disqus/disqus.component';
import { BlogDetailsComponent } from './components/blog/blog-post/blog-details/blog-details.component';
import { BlogListingComponent } from './components/blog/blog-post/blog-listing/blog-listing.component';
import { AppMaterialModule } from './components/blog/_shared';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BlogSidenavComponent } from './components/blog/blog-post/blog-sidenav/blog-sidenav.component';
import { SendEmailComponent } from './send-email/send-email.component';
import * as LogRocket from 'logrocket';
import { PricingComponent } from './components/pricing/pricing.component';
import { QuoteComponent } from './components/quote/quote.component';
import { PsdHtmlComponent } from './components/pricing/inner-pages/psd-html/psd-html.component';
import { CmsEcommerceComponent } from './components/pricing/inner-pages/cms-ecommerce/cms-ecommerce.component';

let localHost = document.location.hostname;

if (localHost == 'richardfreyes.github.io') {
  LogRocket.init('v1yfy5/freyes');

  console.log("logrocket initialize - TRUE");
} else {
  console.log("logrocket initialize - FALSE");
}

// This is an example script - don't forget to change it!
LogRocket.identify('v1yfy5/freyes', {
  name: 'Visitor',
  email: 'visitor@example.com',
});

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'profile', component: ProfileComponent },
  { path: 'resume', component: ResumeComponent },
  { path: 'portfolio', component: PortfolioComponent },
  { path: 'blog', component: BlogComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'blog/:slug', component: BlogDetailsComponent },
  { path: 'freelance-pricing', component: PricingComponent },
  { path: 'freelance-pricing/psd-html', component: PsdHtmlComponent },
  { path: 'freelance-pricing/cms-ecommerce', component: CmsEcommerceComponent },
  { path: 'quote', component: QuoteComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    ProfileComponent,
    PortfolioComponent,
    BlogComponent,
    ContactComponent,
    FooterComponent,
    ResumeComponent,
    DisqusComponent,
    BlogDetailsComponent,
    BlogListingComponent,
    BlogSidenavComponent,
    SendEmailComponent,
    PricingComponent,
    QuoteComponent,
    PsdHtmlComponent,
    CmsEcommerceComponent
  ],
  imports: [
    BrowserModule,
    OwlModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppMaterialModule,
    WordPressModule.forRoot('http://dev-freyeswebsolutions.pantheonsite.io'),
    NgProgressModule.forRoot(),
    NgProgressRouterModule,
    DisqusModule.forRoot('freyes'),
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: true, // <-- debugging purposes only
        useHash: true
      }
    ),
    AngularFireDatabaseModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebase)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts